// dailyImproveStore.js — renderer side of the daily-improve "What's New" pop-up (F4).
// Reads the last run report (written by the local cron to ~/.apolo/daily-improve-last.json)
// via the dailyImprove IPC, and tracks which report the user has already seen (localStorage,
// keyed by the run's startedAt) so the modal shows once per run with news.

const SEEN_KEY = 'apolo_daily_improve_seen';

/** Fetch the last run report (or null outside Electron / when absent). */
export async function getLastReport() {
  try {
    const w = /** @type {any} */ (typeof window !== 'undefined' ? window : {});
    const report = await w?.apolo?.dailyImprove?.last?.();
    return report || null;
  } catch {
    return null;
  }
}

/** A stable key for a run (its startedAt). */
export function reportKey(report) {
  return String(report?.seenKey || report?.startedAt || '');
}

/** Did this run produce something worth showing (merges, PRs, or a revert)? */
export function hasNews(report) {
  if (!report) return false;
  if (report.reverted) return true;
  return Array.isArray(report.changelog) && report.changelog.length > 0;
}

/** Has the user already seen THIS run's pop-up? */
export function isSeen(report) {
  const key = reportKey(report);
  if (!key) return true; // no key ⇒ nothing to show
  try { return localStorage.getItem(SEEN_KEY) === key; } catch { return false; }
}

/** Should the pop-up open now? (news present AND not yet seen) */
export function shouldShow(report) {
  return hasNews(report) && !isSeen(report);
}

/** Mark this run as seen so the pop-up doesn't reopen. */
export function markSeen(report) {
  const key = reportKey(report);
  try { if (key) localStorage.setItem(SEEN_KEY, key); } catch { /* ignore */ }
}
